
import React from "react";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X, Plus } from "lucide-react";

interface CategoryTagsSectionProps {
  categoryTags: string[];
  onAddTag: (category: string) => void;
  onRemoveTag: (category: string) => void;
}

const STARTUP_CATEGORIES = [
  "Technology", "Healthcare", "Education", "Fintech", "E-commerce",
  "Gaming", "Social Impact", "Sustainability", "AI/ML", "Blockchain",
  "Mobile Apps", "SaaS", "Hardware", "Biotech", "Other"
];

const CategoryTagsSection: React.FC<CategoryTagsSectionProps> = ({
  categoryTags,
  onAddTag,
  onRemoveTag
}) => {
  return (
    <div className="space-y-2">
      <Label>Category Tags</Label>
      <div className="flex flex-wrap gap-2 mb-2">
        {categoryTags.map((tag) => (
          <Badge key={tag} variant="secondary" className="flex items-center gap-1">
            {tag}
            <X
              className="h-3 w-3 cursor-pointer"
              onClick={() => onRemoveTag(tag)}
            />
          </Badge>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {STARTUP_CATEGORIES.filter(cat => !categoryTags.includes(cat)).map((category) => (
          <Button
            key={category}
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onAddTag(category)}
            className="text-xs"
          >
            <Plus className="h-3 w-3 mr-1" />
            {category}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default CategoryTagsSection;
